module.exports = __webpack_public_path__ + "static/img/car_mg_hs.7be09b7f.png";